export default __webpack_public_path__ + "static/media/notification.bad6f88d.mp3";